<div class="header">
  @if (walletState()?.name) {
    <p class="wallet-name" id="wallet-details-lbl-name">{{ walletState()?.name }}</p>
  }

  <div class="action-column">
    <a
      id="wallet-details-btn-delete"
      (click)="handleDeleteDialog()"
      [matTooltip]="deleteTooltip"
      matTooltipClass="custom-tooltip"
      >
      <em class="far fa-trash-alt"></em>
    </a>
    @if (!isAlert30DaysWallet()) {
      <a
        id="wallet-details-btn-edit"
        (click)="handleEditWallet()"
        [matTooltip]="editTooltip"
        matTooltipClass="custom-tooltip"
        >
        <em class="fas fa-pencil-alt"></em>
      </a>
    }
    <a
      id="wallet-details-btn-favorite"
      (click)="handleToggleFavorite()"
      [matTooltip]="favoriteTooltip()"
      matTooltipClass="custom-tooltip"
      >
      <em
        [class]="walletState()?.favorite ? 'fas fa-star' : 'far fa-star'"
      ></em>
    </a>
  </div>
</div>

<app-generic-table
  [id]="'wallet-details-table'"
  [data]="trackingRegistries()"
  [config]="tableConfig"
  [isLoading]="isLoading()"
  [showPagination]="true"
  [page]="currentPage()"
  [pageSize]="pageSize"
  [totalRegisters]="totalRecords()"
  (pageChange)="onPageChange($event)"
  >
  <ng-template #noDataContent>
    <div class="empty-state" i18n="@@noDataDisplay">
      No hay datos para mostrar.
    </div>
  </ng-template>
</app-generic-table>
